if (!window._resourceCarouselInitialized) {
  window._resourceCarouselInitialized = true;

const BASE_OPTIONS = {
  align: 'start',
  dragFree: false,
  skipSnaps: false,
  watchResize: true,
  watchSlides: true,
};

class ResourceCarousel extends HTMLElement {
  connectedCallback() {
    if (this.embla) return;

    const Embla = window.EmblaCarousel;
    if (!Embla) {
      document.addEventListener('embla:ready', () => this.connectedCallback(), { once: true });
      return;
    }

    const viewport = this.querySelector('[data-embla-viewport]');
    if (!viewport) return;

    const loop = this.dataset.emblaLoop === 'true';
    const options = loop
      ? { ...BASE_OPTIONS, loop: true }
      : { ...BASE_OPTIONS, containScroll: 'trimSnaps' };

    this.embla = Embla(viewport, options);

    this.prevBtn = this.querySelector('[data-embla-prev]');
    this.nextBtn = this.querySelector('[data-embla-next]');
    this.dotsContainer = this.querySelector('[data-embla-dots]');
    this.dotButtons = [];

    this.handlePrev = () => this.embla?.scrollPrev();
    this.handleNext = () => this.embla?.scrollNext();
    this.prevBtn?.addEventListener('click', this.handlePrev);
    this.nextBtn?.addEventListener('click', this.handleNext);

    this.renderDots();
    this.updateControls();

    this.embla
      .on('init', () => {
        this.renderDots();
        this.updateControls();
      })
      .on('reInit', () => {
        this.renderDots();
        this.updateControls();
      })
      .on('select', () => this.updateControls());
  }

  renderDots() {
    if (!this.dotsContainer || !this.embla) return;

    this.dotButtons.forEach((btn) => btn.removeEventListener('click', btn._emblaHandler));
    this.dotsContainer.replaceChildren();

    const snaps = this.embla.scrollSnapList();
    if (snaps.length <= 1) {
      this.dotsContainer.hidden = true;
      this.dotButtons = [];
      return;
    }

    this.dotsContainer.hidden = false;
    this.dotButtons = snaps.map((_, index) => {
      const li = document.createElement('li');
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'embla__dot';
      btn.setAttribute('aria-label', `Go to slide ${index + 1}`);
      btn._emblaHandler = () => this.embla?.scrollTo(index);
      btn.addEventListener('click', btn._emblaHandler);
      li.append(btn);
      this.dotsContainer.append(li);
      return btn;
    });
  }

  updateControls() {
    if (!this.embla) return;

    if (this.prevBtn) this.prevBtn.toggleAttribute('disabled', !this.embla.canScrollPrev());
    if (this.nextBtn) this.nextBtn.toggleAttribute('disabled', !this.embla.canScrollNext());

    const selected = this.embla.selectedScrollSnap();
    this.dotButtons.forEach((btn, i) => {
      if (i === selected) btn.setAttribute('aria-selected', 'true');
      else btn.removeAttribute('aria-selected');
    });
  }

  disconnectedCallback() {
    this.prevBtn?.removeEventListener('click', this.handlePrev);
    this.nextBtn?.removeEventListener('click', this.handleNext);
    this.dotButtons.forEach((btn) => btn.removeEventListener('click', btn._emblaHandler));
    this.embla?.destroy();
    this.embla = null;
    this.dotButtons = [];
  }
}

if (!customElements.get('resource-carousel')) {
  customElements.define('resource-carousel', ResourceCarousel);
}

if (window.EmblaCarousel) {
  document.dispatchEvent(new CustomEvent('embla:ready'));
} else {
  const checkReady = () => {
    if (window.EmblaCarousel) {
      document.dispatchEvent(new CustomEvent('embla:ready'));
      return true;
    }
    return false;
  };
  if (!checkReady()) {
    window.addEventListener('load', checkReady, { once: true });
  }
}

}
